// @flow

import { connect } from 'react-redux';
import { useQuery, useMutation } from '@apollo/react-hooks';

import { RouterSelectors } from '@zapier/toolbox-redux-framework';
import { UniversalNavProvider } from '@zapier/universal-nav';

import { Account } from '@zapier/shared-entities';
import { getAccountSwitcherUrl } from 'app/common/middlewares/accountSwitcherMiddleware';

const mapStateToProps = state => {
  return {
    accountSwitcherUrl: getAccountSwitcherUrl(state),
    currentAccountId: Account.selectors.all.currentAccountId(state),
    currentUrl: RouterSelectors.currentUrl(state) || '',
    useMutation,
    useQuery,
  };
};

export default connect(mapStateToProps)(UniversalNavProvider);
